// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__3Z_qQ","label":"Completed_label__3dnFT"};